import { Typography } from "@material-ui/core"
import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
import { CostDetailCollection, CostDetailProps, CurrencyWithColor, formatCurrency } from "../components/CostDetail"
import Table, { TableColumn } from "../components/Table"
import { OrderContext, OrderSimulationData, RequestLineItem } from "../OrderContext"
import { ResponseLineItem } from "./types"

type PurchaseDisplayProps = { disableSmall?: boolean, simulateOverride?: OrderSimulationData }

const PurchaseDisplay: React.FC<PurchaseDisplayProps> = ({ disableSmall, simulateOverride }) => {
    const { simulate } = useContext(OrderContext)
    const { t } = useTranslation()

    const s = simulateOverride || simulate

    if (!s) return null

    const columns: TableColumn<ResponseLineItem & RequestLineItem>[] = [
        { title: t('description'), property: 'description', flex: 3 },
        { title: t('material_number'), property: 'material', flex: 2 },
        { title: '', filler: true, property: 'material', render: () => null },
        { title: '', filler: true, property: 'material', render: () => null, flex: 2 },
        { title: t('unit_price'), property: 'unitPrice', render: p => formatCurrency(p as number) },
        { title: t('quantity'), property: 'quantity' },
        { title: t('total_in', { currency: s.currency }), property: 'netAmount', align: 'right', render: a => <CurrencyWithColor amount={a as number} />, flex: 2 },
    ]

    const costDetails: CostDetailProps[] = [
        { label: t('subtotal_exchange'), amount: s?.replacementSubtotal || 0 },
        { label: t('taxes'), amount: s?.replacementTax || 0 },
        { label: t('shipping_cost'), amount: s?.replacementShippingCost || 0 },
        { label: t('total_exchange_items'), amount: s?.replacementTotal || 0 },
    ]

    return s.purchases
        ? <>
            <Typography variant='h5' style={{ marginBottom: 30 }}>{t('exchange_items')}</Typography>

            <Table disableSmall={disableSmall} collapse columns={columns} data={s.purchases} />

            <CostDetailCollection details={costDetails} />
        </>
        : null
}

export default PurchaseDisplay
